
























import { Component, Vue } from 'vue-property-decorator';
import { CommonUtils } from '@/util/commonUtils';

@Component({})
export default class PendingVerification extends Vue {

    private logout() {
        CommonUtils.logout(this.$store.state);
    }
}
